"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTaskEstimation = exports.formatTaskType = exports.formatPullRequestStatus = void 0;
const tslib_1 = require("tslib");
const database_types_1 = require("@acumen/database-types");
const moment_1 = tslib_1.__importDefault(require("moment"));
const __1 = require("../");
function formatPullRequestStatus(status) {
    switch (status) {
        case database_types_1.AcumenPullRequestStatus.Open:
            return "Open";
        case database_types_1.AcumenPullRequestStatus.AwaitingReview:
            return "Awaiting Review";
        case database_types_1.AcumenPullRequestStatus.InReview:
            return "In Review";
        case database_types_1.AcumenPullRequestStatus.Reviewed:
            return "Pending Merge";
        case database_types_1.AcumenPullRequestStatus.Merged:
            return "Merged";
        case database_types_1.AcumenPullRequestStatus.Closed:
            return "Closed";
    }
}
exports.formatPullRequestStatus = formatPullRequestStatus;
function formatTaskType(type) {
    switch (type) {
        case database_types_1.AcumenTaskType.Bug:
            return "Bug";
        case database_types_1.AcumenTaskType["Change Request"]:
            return "Change Request";
        case database_types_1.AcumenTaskType.Epic:
            return "Epic";
        case database_types_1.AcumenTaskType.Improvement:
            return "Improvement";
        case database_types_1.AcumenTaskType["New Feature"]:
            return "New Feature";
        case database_types_1.AcumenTaskType.Story:
            return "Story";
        case database_types_1.AcumenTaskType["Sub-Task"]:
            return "Sub-Task";
        case database_types_1.AcumenTaskType.Task:
            return "Task";
        case database_types_1.AcumenTaskType["Technical Task"]:
            return "Technical Task";
        case database_types_1.AcumenTaskType.Support:
            return "Support";
        case database_types_1.AcumenTaskType.Security:
            return "Security";
        case database_types_1.AcumenTaskType.Documentation:
            return "Documentation";
    }
}
exports.formatTaskType = formatTaskType;
function formatTaskEstimation(method, value) {
    switch (method) {
        case database_types_1.TaskEstimationMethod.None:
            return `${value}`;
        case database_types_1.TaskEstimationMethod.StoryPoints:
            return `${value} Story Points`;
        case database_types_1.TaskEstimationMethod.TShirtSize:
            return `T-Shirt Size ${value}`;
        case database_types_1.TaskEstimationMethod.TimeBased:
            const valueInSeconds = value;
            const valueInDays = moment_1.default.duration(valueInSeconds, "seconds").asDays();
            if (valueInDays >= 1) {
                const roundedValueInDays = __1.round(valueInDays, 1);
                return `${__1.inflect(roundedValueInDays, "day", "days")}`;
            }
            const roundedValueInHours = __1.round(moment_1.default.duration(valueInSeconds, "seconds").asHours(), 1);
            return `${__1.inflect(roundedValueInHours, "hour", "hours")}`;
    }
}
exports.formatTaskEstimation = formatTaskEstimation;
//# sourceMappingURL=text-template-helpers.js.map